import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import 'antd/dist/reset.css'
import App from './App.jsx'
import { SessionProvider } from './console/SessionContext'
import { applyBrandChrome } from './brand/brandConfig'

// Set the tab title + favicon from the endpoint's brand before first paint.
applyBrandChrome()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <SessionProvider>
      <App />
    </SessionProvider>
  </StrictMode>,
)
